module.exports = __webpack_public_path__ + "static/media/Home Page_website-23.0b9aecef.png";